import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import * as gridItensActions from 'app/redux/gridItensSlice'
import globalMU from "globalMU";
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { IOrcamento } from "app/types/IOrcamento";

export type RemoverServicosAgregadosOutput = {
    status: "SUCESSO" | "ERRO"
}

declare var window: any

export async function RemoverServicosAgregados(identificadorOrcamento: string, identificadorItem: number): Promise<RemoverServicosAgregadosOutput> {

    try {
        globalMU.blockUI()

        const orcamentoLegado = window.orcamentoController.model

        const resposta = await microuniversoApi.Orcamento.removerServicosAgregados(
            identificadorOrcamento, 
            identificadorItem);

         orcamentoLegado.atualizar(resposta, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(resposta as IOrcamento))

        store.dispatch(gridItensActions.atualizarFlagAction())
        return {
            status: "Error" in resposta ? "ERRO" : "SUCESSO"
        }

    } finally {
        globalMU.unblockUI()
    }
}